import { render, staticRenderFns } from "./PochoirView.vue?vue&type=template&id=d079fa2a"
import script from "./PochoirView.vue?vue&type=script&lang=js"
export * from "./PochoirView.vue?vue&type=script&lang=js"
import style0 from "./PochoirView.vue?vue&type=style&index=0&id=d079fa2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports